import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, inject, input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ChartConfiguration } from 'chart.js';
import { BarChartComponent } from '../../shared/components/bar-chart/bar-chart.component';
import { PrintFilterDataComponent } from '../../shared/components/print-filter-data/print-filter-data.component';
import { IReportFilter } from '../../utils/interfaces/report-filter';
import { PrintDocument } from '../print-document';

interface IPrintShiftData {
  data: ChartConfiguration<'bar'>['data'];
  filter: IReportFilter;
  totalResponses: number;
  overallSatisfaction: number;
}

@Component({
  selector: 'app-print-shift',
  standalone: true,
  host: {
    '[class.embedded]': 'embedded()',
  },
  imports: [CommonModule, PrintFilterDataComponent, BarChartComponent],
  templateUrl: '../../main/report/report-data/shift/shift.component.html',
  styleUrl: '../../main/report/report-data/shift/shift.component.scss',
  styles: [
    `
      :host.embedded app-print-filter-data {
        display: none;
      }
    `,
  ],
})
export class PrintShiftComponent 
  extends PrintDocument 
  implements OnInit, AfterViewInit 
{
  embedded = input(false);
  embeddedData = input<ChartConfiguration<'bar'>['data'] | null>(null);
  embeddedFilter = input<IReportFilter | null>(null);
  embeddedTotalResponses = input(0);
  embeddedOverallSatisfaction = input(0);

  print = true;
  orientation = 'portrait';  
  data!: ChartConfiguration<'bar'>['data'];
  filter!: IReportFilter;
  totalResponses = 0;
  overallSatisfaction = 0;

  private readonly titleService = inject(Title);

  ngOnInit(): void {
    this.handleData();
  }

  ngAfterViewInit(): void {
    this.reportReadyData();
  }

  protected override handleData(): void {
    if (this.embedded()) {
      this.data = this.embeddedData() as ChartConfiguration<'bar'>['data'];
      this.filter = this.embeddedFilter() as IReportFilter;
      this.totalResponses = this.embeddedTotalResponses();
      this.overallSatisfaction = this.embeddedOverallSatisfaction();
      return;
    }

    const printData: IPrintShiftData = (<any>window).data;    
    this.data = printData.data;
    this.filter = printData.filter;
    this.totalResponses = printData.totalResponses;
    this.overallSatisfaction = printData.overallSatisfaction;
    
    this.titleService.setTitle(
      this.changeTitlePage(
        'Relatório Comparativo por Turno',
        this.filter.startDate,
        this.filter.finishDate
      )
    );
  }

  protected override reportReadyData(): void {
    if (this.embedded()) {
      return;
    }

    setTimeout(() => {
      this.printDocumentService.onDataReady();
    }, 3000);
  }
}
